import { Application } from '../../blocks/common/components/application';
import { SearchApps } from '../../blocks/common/applications/search-apps';

class Main extends Application {
    async init() {
        await super.init();

        const searchApps = new SearchApps();
        searchApps.init(this.store);
    }
}

const application = new Main();
application.init();
window['application'] = application;